import * as $ from 'jquery';
import * as Cookie from 'es-cookie/src/es-cookie';
import TranslationsService from '../services/translationsService';

const PRO_BROWSING_COOKIE_NAME = 'ProProductBrowsingEnabled';
const translationsService = TranslationsService.getInstance();

function initProBrowsingToggle() {
	$('.js-pro-browsing-toggle').on('click', function() {
		if (Cookie.get(PRO_BROWSING_COOKIE_NAME)) {
			Cookie.remove(PRO_BROWSING_COOKIE_NAME);
		} else {
			Cookie.set(PRO_BROWSING_COOKIE_NAME, 'true', { path: '/', 'expires': 7 });
		}
		location.reload();
	});

	$('.js-pro-browsing-cancel').on('click', function() {
		Cookie.remove(PRO_BROWSING_COOKIE_NAME);
		location.reload();
	});
}

// Sometimes the page markup gets cached/stuck, so update it with JS if necessary
function updateUI() {
	if (Cookie.get(PRO_BROWSING_COOKIE_NAME)) {
		let $label = $('[data-i18n="ProBrowsingLabel"]');
		let $button = $('[data-i18n="ProBrowsingButton"]');

		$label.text( translationsService.translate('ProBrowsing.CurrentlyProBrowsing') );
		$button.text( translationsService.translate('ButtonLabels.BrowseAllProducts') );
	} else {
		let $alert = $('.js-pro-browsing-alert');
		$alert.remove();
	}
}

export function init() {
	if ($("#pro-browsing-translations").length) {
		translationsService.addTranslations('pro-browsing-translations');

		updateUI();
		initProBrowsingToggle();
	}
}


// WEBPACK FOOTER //
// ./js/PFF/modules/proBrowsingToggle.ts